<template>
  <page-header titolo="Tabelle" icona="fa-table-cells" sfondo="bkg-tabelle"></page-header>

  <div class="pol-container">
    <div class="card" >
      <div class="card-header">
        <h3>Gestione tabelle servizio</h3>
      </div>
      <div class="card-body">
        

        <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" href="#" @click="AttivaPannello(1)" :class="{'active' : mostraPnl1}">Documenti tipo</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" @click="AttivaPannello(2)" :class="{'active' : mostraPnl2}">Documenti categoria</a>
        </li>
        
        
      </ul>
      <br />

      <!-- ****** PANNELLO 1 : DOCUMENTI TIPO ***** -->
      <div v-if="mostraPnl1">
        <div class="row mb-3">
          <div class="col-md-12">
            <font-awesome-icon icon="fa-solid fa-table-list"></font-awesome-icon>&nbsp;
            <u>Documenti tipo</u>
          </div>
       
        </div>
    
        
        <table class="table table-sm table-striped tblPoliDoc">
          <thead>
            <tr>
              <th style="width:50px;">Id</th>
              <th>Titolo</th>
              <th style="width:120px;">Validità anni</th>
              <th>Colore</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tp, n in dtDocumentiTipo" :key="n">
              <!-- dtp_id-->
              <td>{{ tp.dtp_id }}</td>
              <!-- dtp_titolo-->
              <td v-if="!tp.edit">{{ tp.dtp_titolo }}</td>
              <td v-else><input type="text" class="form-control" v-model="tp.dtp_titolo"></td>
              <!-- dtp_validita-->
              <td v-if="!tp.edit">{{ tp.dtp_validita }}</td>
              <td v-else><input type="number" class="form-control" v-model="tp.dtp_validita" style="width:100px;"></td>
              <!-- dtp_colore-->
              <td v-if="!tp.edit"><div class="divMiniBox" :style="'background-color:' + tp.dtp_colore + ' ;'"></div>&nbsp;{{ tp.dtp_colore }} </td>
              <td v-else>
                Scegli colore: <input type="color" v-model="tp.dtp_colore">
              </td>
              <!-- * Azioni * -->
              <td>
                <button type="button" class="btn btn-sm btn-outline-danger" @click="CancellaDocTipo(tp)" title="Cancella">
                    <font-awesome-icon icon="fa-solid fa-trash"></font-awesome-icon>
                </button> &nbsp;
                <template v-if="!tp.edit">
                    <button type="button" class="btn btn-sm btn-outline-warning" @click="EditDocTipo(tp)" title="Modifica">
                        <font-awesome-icon icon="fa-solid fa-edit"></font-awesome-icon>
                    </button> 
                </template>
                <template v-else>
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="SalvaDocTipo(tp)" title="Salva modifiche">
                        <font-awesome-icon icon="fa-solid fa-floppy-disk"></font-awesome-icon>
                    </button>&nbsp;
                    <button type="button" class="btn btn-sm btn-outline-dark" @click="AnnullaDocTipo(tp)" title="Annulla">
                        <font-awesome-icon icon="fa-solid fa-times"></font-awesome-icon>
                    </button> 
                </template>

              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td><font-awesome-icon icon="fa-solid fa-plus"></font-awesome-icon></td>
              <td>
                <input type="text" class="form-control" placeholder="inserire il titolo" v-model="oNewDocTipo.dtp_titolo">
              </td>
              <td>
                <input type="number" class="form-control" placeholder="anni validità" v-model="oNewDocTipo.dtp_validita">
              </td>
              <td>
                Scegli colore:&nbsp;<input type="color" v-model="oNewDocTipo.dtp_colore">
              </td>
              <td>
                <button type="button" class="btn btn-sm btn-outline-primary" @click="SalvaDocTipo()" title="Inserisci">
                    <font-awesome-icon icon="fa-solid fa-floppy-disk"></font-awesome-icon>&nbsp;Inserisci
                </button> &nbsp;

              </td>
            </tr>
            
          </tfoot>
        </table>
      </div>

      <!-- ****** PANNELLO 2 : DOCUMENTI CATEGORIA ***** -->
      <div v-if="mostraPnl2">
        <div class="row mb-3">
          <div class="col-md-12 ">
            <font-awesome-icon icon="fa-solid fa-table-list"></font-awesome-icon>&nbsp;
            <u>Documenti categoria</u>
          </div>

          <table class="table table-sm table-striped tblPoliDoc">
          <thead>
            <tr>
              <th style="width:50px;">Id</th>
              <th>Tipo</th>
              <th>Titolo</th>
              <th>Validità</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ct, n in dtDocumentiCategorie" :key="n">
              <!-- dtc_id-->
              <td>{{ ct.dtc_id }}</td>
              <!-- dtc_idTipo-->
              <td v-if="!ct.edit">{{ ct.dtp_titolo }}</td>
              <td v-else>
                <select class="form-control" v-model="ct.dtc_idTipo">
                  <option v-for="o, n in dtDocumentiTipo" :key="n" :value="o.dtp_id">{{ o.dtp_titolo }}</option>
                </select>
              </td>
              <!-- dtc_titolo-->
              <td v-if="!ct.edit">{{ ct.dtc_titolo }}</td>
              <td v-else><input type="text" class="form-control" v-model="ct.dtc_titolo"></td>
              <!-- dtp_validita-->
              <td v-if="!ct.edit">{{ ct.dtc_validita }}</td>
              <td v-else><input type="number" class="form-control" v-model="ct.dtc_validita" style="width:100px;"></td>
              <!-- * Azioni * -->
              <td>
                <button type="button" class="btn btn-sm btn-outline-danger" @click="CancellaDocCategoria(ct)" title="Cancella">
                    <font-awesome-icon icon="fa-solid fa-trash"></font-awesome-icon>
                </button> &nbsp;
                <template v-if="!ct.edit">
                    <button type="button" class="btn btn-sm btn-outline-warning" @click="EditDocCategoria(ct)" title="Modifica">
                        <font-awesome-icon icon="fa-solid fa-edit"></font-awesome-icon>
                    </button> 
                </template>
                <template v-else>
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="SalvaDocCategoria(ct)" title="Salva modifiche">
                        <font-awesome-icon icon="fa-solid fa-floppy-disk"></font-awesome-icon>
                    </button>&nbsp;
                    <button type="button" class="btn btn-sm btn-outline-dark" @click="AnnullaDocCategoria(ct)" title="Annulla">
                        <font-awesome-icon icon="fa-solid fa-times"></font-awesome-icon>
                    </button> 
                </template>

              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td><font-awesome-icon icon="fa-solid fa-plus"></font-awesome-icon></td>
              <td>
                <select class="form-control" v-model="oNewDocCat.dtc_idTipo">
                  <option v-for="o, n in dtDocumentiTipo" :key="n" :value="o.dtp_id">{{ o.dtp_titolo }}</option>
                </select>
              </td>
              <td>
                <input type="text" class="form-control" placeholder="titolo categoria" v-model="oNewDocCat.dtc_titolo">
              </td>
              <td>
                <input type="number" class="form-control" v-model="oNewDocCat.dtc_validita" style="width:100px;">
              </td>
              <td>
                <button type="button" class="btn btn-sm btn-outline-primary" @click="SalvaDocCategoria()" title="Inserisci">
                    <font-awesome-icon icon="fa-solid fa-floppy-disk"></font-awesome-icon>&nbsp;Inserisci
                </button> &nbsp;

              </td>
            </tr>
            
          </tfoot>
        </table>
       
        </div>

      </div>


    </div>

      


    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: { PageHeader },
  inject: ['cfg'],
  data: function () {
    return {
      
      dtDocumentiTipo: [],
      dtDocumentiCategorie: [],

      mostraPnl1: true,
      mostraPnl2: false,

      oNewDocTipo: {
        dtp_id : -1,
        dtp_titolo : "",
        dtp_validita : 0,
        dtp_colore : "#ffffff",

        //Campi custom 
        edit : false,
        token : "",
      },

      oNewDocCat : {
        dtc_id : -1,
        dtc_idTipo : -1,
        dtc_titolo : "",
        dtc_validita : 0,
        dtp_titolo : "",

        //Campi custom 
        edit : false,
        token : "",

      },

    }
  },
  methods: {
    AttivaPannello(pnl) {
      if(pnl==1) {
        this.GetListDocumentiTipo();

        this.mostraPnl1 = true;
        this.mostraPnl2 = false;
      }
      if(pnl==2) {
        this.GetListDocumentiCategoria();

        this.mostraPnl1 = false;
        this.mostraPnl2 = true;
      }
    },

    //**** TIPO DOCUMENTI ****/

    GetListDocumentiTipo() {
      //Carica lista elementi
      fetch(this.cfg.apisrv + "/api/Documenti/GetListDocumentiTipo?token=" + this.$store.state.UserInfo.token)
          .then(response => response.json())
          .then(obj => {
              this.dtDocumentiTipo = obj;
          });
    },
    EditDocTipo(e) {
      e.edit = true;
    },
    SalvaDocTipo(e) {
      let oSubmit = {};
      if(e == undefined ) oSubmit = this.oNewDocTipo;
      else oSubmit = e;
      oSubmit.token = this.$store.state.UserInfo.token;

      fetch(this.cfg.apisrv +"/api/Documenti/SalvaDocumentiTipo", {
          "method": "POST",
          "headers": {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
          },
          "body": JSON.stringify(oSubmit)
      }).then(response => response.json())
          .then(obj => {
              if (obj.status == "OK") {
                  this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});

                  this.GetListDocumentiTipo();
                  
              }
              else {
                  
              }
          });
    },
    CancellaDocTipo(e) {
      //Cancella elemento singolo
      if(confirm("Cancellare l'elemento?")) {
        fetch(this.cfg.apisrv + "/api/Documenti/DelDocumentiTipo?token=" + this.$store.state.UserInfo.token + "&idTipo=" + e.dtp_id)
            .then(response => response.json())
            .then(obj => {
              if (obj.status == "OK") { 
                this.$store.commit('Messaggio', {parms: [true, ['Cancellato.'], 'alert alert-success', 'fa-check', false, 2000]});

                this.GetListDocumentiTipo();
              } else {
                this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 4000]});
              }
                
            });
        }
    },
    AnnullaDocTipo(e) {
      e.edit = false;
      this.GetListDocumentiTipo();
    },


    //**** CATEGORIA DOCUMENTI ****/

    GetListDocumentiCategoria() {
      //Carica lista elementi
      fetch(this.cfg.apisrv + "/api/Documenti/GetListDocumentiCategoria?token=" + this.$store.state.UserInfo.token)
          .then(response => response.json())
          .then(obj => {
              this.dtDocumentiCategorie = obj;
          });
    },
    EditDocCategoria(e) {
      e.edit = true;
    },
    SalvaDocCategoria(e) {
      let oSubmit = {};
      if(e == undefined ) oSubmit = this.oNewDocCat;
      else oSubmit = e;
      oSubmit.token = this.$store.state.UserInfo.token;

      fetch(this.cfg.apisrv +"/api/Documenti/SalvaDocumentiCategoria", {
          "method": "POST",
          "headers": {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
          },
          "body": JSON.stringify(oSubmit)
      }).then(response => response.json())
          .then(obj => {
              if (obj.status == "OK") {
                  this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});

                  this.GetListDocumentiCategoria();
                  
              }
              else {
                  
              }
          });
    },
    CancellaDocCategoria(e) {
      //Cancella elemento singolo
      if(confirm("Cancellare l'elemento?")) {
        fetch(this.cfg.apisrv + "/api/Documenti/DelDocumentiCategoria?token=" + this.$store.state.UserInfo.token + "&idCat=" + e.dtc_id + "&idTipo=" + e.dtc_idTipo)
            .then(response => response.json())
            .then(obj => {
              if (obj.status == "OK") { 
                this.$store.commit('Messaggio', {parms: [true, ['Cancellato.'], 'alert alert-success', 'fa-check', false, 2000]});

                this.GetListDocumentiCategoria();
              } else {
                this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 4000]});
              }
                
            });
        }
    },
    AnnullaDocCategoria(e) {
      e.edit = false;
      this.GetListDocumentiCategoria();
    },
    
  },
  mounted: function() {
    if(this.$store.state.UserInfo.token == '') this.$router.push("/");

    this.GetListDocumentiTipo();
    
  }
}
</script>

<style scoped>



</style>